module.exports = __webpack_public_path__ + "img/Master-4.90a4ddf4.gif";